import { Link } from 'react-router-dom'

import { useCampaignMenuActions } from '@components/Campaign/Menu'
import { ActionIconWrapper } from '@components/Inbox/TitleBar/TitleBar.styled'
import ActionIcon from '@components/UI/ActionIcon'
import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { useIntl } from '@context/Internationalization/useIntl'
import { EventTrackingNames } from '@enums'
import Theme from '@theme'

export const InboxTitleBarEditAction: React.FC<{ campaignId: number }> = ({ campaignId }) => {
  const { editLink } = useCampaignMenuActions()
  const { intl } = useIntl()

  if (!editLink) {
    return null
  }

  return (
    <ActionIconWrapper>
      <ConnectedTrackedRoute
        eventName={EventTrackingNames.CampaignBuilderEditCampaign}
        campaignId={campaignId}
      >
        <Link to={editLink}>
          <ActionIcon
            glyph="edit"
            highlighted={false}
            showNotification={false}
            color={Theme.grey900Color}
            tooltip={intl.formatMessage({ id: 'inbox.titlebar.action.editCampaign' })}
            size={1.5}
            elementName="edit-campaign"
          />
        </Link>
      </ConnectedTrackedRoute>
    </ActionIconWrapper>
  )
}

export default InboxTitleBarEditAction
